<template>
  <div>
    <HeadingExtraSmall
      :hasMargin="false"
    >
      Access
    </HeadingExtraSmall>
    <ChoiceChipGroup
      :class="$style.accessSelect"
      name="action-select"
      :options="accessActions"
      :value="accessValue"
      @input="handleActionChange"
    />
    <HeadingExtraSmall
      :hasMargin="false"
    >
      Authentication
    </HeadingExtraSmall>
    <ChoiceChipGroup
      :isDisabled="!isEnabled"
      name="authentication-select"
      :options="authenticationActions"
      :value="value"
      @input="handleActionChange"
    />
  </div>
</template>

<script>
import { AuthnPolicyConsts } from 'client/util/Constants';
import { ChoiceChipGroup, HeadingExtraSmall } from '@jumpcloud/ui-components';

const { policyActions } = AuthnPolicyConsts;

export default {
  name: 'ActionSelector',

  components: {
    ChoiceChipGroup,
    HeadingExtraSmall,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    accessActions() {
      return [
        { name: 'Allowed', value: policyActions.allow },
        { name: 'Denied', value: policyActions.deny },
      ];
    },

    accessValue() {
      return this.isEnabled ? policyActions.allow : policyActions.deny;
    },

    authenticationActions() {
      return [
        {
          name: 'Password',
          value: policyActions.allow,
        },
        {
          name: 'Password + MFA',
          value: policyActions.allowWithMFA,
        },
      ];
    },

    isEnabled() {
      return [policyActions.allow, policyActions.allowWithMFA].includes(this.value);
    },
  },

  methods: {
    handleActionChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style module>
  .accessSelect.accessSelect {
    margin-bottom: 2rem;
  }
</style>
